export default {
    namespaced: true,
    state() {
        return {
            insured: window?.data?.order?.insurance ? !!window?.data?.order?.insurance?.amount : true,
            amount: window?.data?.order?.insurance?.amount ?? undefined,
        }
    },
    getters: {
        cost(state) {
            return state.insured && state.amount
                ? state.amount * process.env.MIX_SALES_INSURANCE
                : undefined;
        },
        completed(state) {
            return !state.insured || !!state.amount;
        },
        form(state) {
            return {
                amount: state.amount,
            };
        },
    },
    mutations: {
        setInsured(state, insured) {
            state.insured = insured;
        },
        setAmount(state, amount) {
            state.amount = amount;
        },
    },
}
